@if (!isLoading()) {
  @if (!noHeader() && isShowButtons()) {
    <div class="buttons g-flex g-flex--align-center g-flex--space-between">
      <button
        class="btn-header-marketplace"
        [routerLink]="[MAIN_ROUTES.MAIN, MAIN_ROUTES.PAWNSHOP]"
        routerLinkActive="app-btn_active"></button>

      <button
        class="btn-header-guild"
        [routerLink]="[MAIN_ROUTES.MAIN, MAIN_ROUTES.GUILDS]"
        routerLinkActive="app-btn_active"></button>

      <button
        class="btn-header-adventure"
        [disabled]="!selectedHero()"
        [routerLink]="getAdventureRoute()"
        routerLinkActive="app-btn_active"></button>

      <button
        class="btn-header-daily"
        [routerLink]="[MAIN_ROUTES.MAIN, MAIN_ROUTES.DAILY_QUESTS]"
        routerLinkActive="app-btn_active"></button>

      <button
        class="btn-header-reinforcement"
        [disabled]="!selectedHero()"
        [routerLink]="[MAIN_ROUTES.REINFORCEMENT, selectedHero()?.meta?.id, selectedHero()?.heroId]"
        routerLinkActive="app-btn_active"></button>
    </div>

    <div class="bg"></div>
  }
}
